import React from 'react';
import Button, { ILink } from 'tbk-components/src/components/Button';
import SocialIcons, { ISocialIconsProps } from '../SocialIcons';
import { useTranslation } from 'react-i18next';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import cn from 'classnames';

export interface ICPTShareBannerProps extends IBaseElementProps {
	downloadBtn?: ILink;
	socialIcons?: ISocialIconsProps;
	shareLabel?: string;
}

/**
 * Calian CPT Share Banner
 * @block
 */
const CPTShareBanner: React.FC<ICPTShareBannerProps> = ({
	id,
	className,
	classNames = [],
	downloadBtn,
	socialIcons,
	shareLabel,
}) => {
	const { t } = useTranslation();
	return (
		<div
			id={id}
			className={
				className || cn('cpt-share-banner__container', ...classNames)
			}
		>
			<div className="cpt-share-banner__container-inner">
				{downloadBtn?.href && (
					<div className="cpt-share-banner__left">
						<Button
							{...downloadBtn}
							className="btn btn-primary btn-sm"
						>
							<i className="icon icon-download-simple"></i>
						</Button>
					</div>
				)}
				<div className="cpt-share-banner__right">
					{socialIcons?.icons?.length > 0 && (
						<div>
							{shareLabel || t('Share:')}
							<SocialIcons {...socialIcons} />
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default CPTShareBanner;
